export interface ValidationError {
  [key: string]: string[];
}

export class ApiError extends Error {
  public errors?: ValidationError;

  constructor(message: string, errors?: ValidationError) {
    super(message);
    this.errors = errors;
  }
}
